import React from "react";

import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const SportsBookAuth = ({ children }) => {
  const { pathname } = useLocation();
  const { SbPermission, agentSbPermission } = useSelector(
    (state) => state.myProfile
  );
  const loading = useSelector((state) => state.myProfile.loading);

  const isAuthenticated =
    localStorage.getItem("authSession") == null ? false : true;

  if (isAuthenticated && !loading) {
    if (SbPermission !== undefined && agentSbPermission !== undefined) {
      if (SbPermission && agentSbPermission && !loading) {
        return children;
      }
      if (
        (!SbPermission || !agentSbPermission) &&
        pathname.includes("sportsbook")
      ) {
        return <Navigate to="/" />;
      }
    }
    return;
  } else {
    return children;
  }
};

export default SportsBookAuth;
